/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
// import config from "../config/issueCredential.config.json";
// import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPSERT_PORTFOLIO } from "../graphql";
import { VApplication } from "../../../application";
import {useCollection} from "../provider";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISavePortfolioMethods extends IPluginMethodMap {
  getSavePortfolio(args: any): Promise<any>;
}

export interface SavePortfolioProps {
  formData: any;
  id:string;
  name:string;
  evidence:any;
  tempId:string;
}

export class SavePortfolioService implements IAgentPlugin {
  readonly methods: ISavePortfolioMethods;

  constructor() {
    this.methods = {
      getSavePortfolio: this.getSavePortfolio.bind(this),
    };
  }

  async getSavePortfolio(args: SavePortfolioProps) {
    console.log(`args in issue credential`, args);
    const {portfolioTempId} = useCollection();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    delete args?.formData["id"];
    console.log(`formData:::`, args?.formData);
    let _evidence =
      Array.isArray(args?.evidence) &&
      args?.evidence.map((item) => {
        return {
          id: item?.base64,
          evidenceDocument: item?.name,
          evidenceDocumentType: item?.type,
        };
      });

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPSERT_PORTFOLIO,
          variables: {
            input:{
              portfolioTempId:args?.tempId,
              submit:false,
              credential:{
                credentialSubject: await this.getCredentialSubject(args?.formData),
                evidence:await this.getEvidence(args?.formData, _evidence),
                id:args?.id,
              }
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.upsertPortfolio) {
          console.log(`table data`, res);
          return {
            ...res?.data?.upsertPortfolio,
          };
        }
      }
    } catch (err: any) {
      console.log("error in issue credential", err?.message);
      throw err;
    }
  }

  private getEvidence(formData: any, evidence:any[]) {
    console.log(`formData in get Evidence`, formData);
    let _evidence: any = [];
    Object.entries(formData).forEach(([key, value]) => {
      if (Array.isArray(value) && value?.length > 0) {
        value.forEach(ele => {
          if (ele?.type && ele?.file) {
            _evidence.push({
              evidenceDocumentType: ele?.type,
              evidenceDocument: ele?.name,
              id: ele?.base64,
            })
          }
        })
      }
      else if(typeof value ==="object"){
            _evidence.push({
              evidenceDocumentType: value?.type,
              evidenceDocument: value?.name,
              id: value?.base64,
            });
      }
    })
    if(Array.isArray(evidence) && evidence?.length > 0 ){
      _evidence = [..._evidence, ...evidence];
    }
    return _evidence;
  }

  private getCredentialSubject(formData:any){
    let _credentialSubject:any = {...formData};
    Object.entries(_credentialSubject).forEach(([key, value]) => {
      if(Array.isArray(value)){
        delete _credentialSubject[key];
      }
    });
    return _credentialSubject;
  }
}
